import { render, staticRenderFns } from "./Agences.vue?vue&type=template&id=206f61b8&"
import script from "./Agences.vue?vue&type=script&lang=js&"
export * from "./Agences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports